export default __webpack_public_path__ + "static/media/MY.986f4041.svg";